import React, { ReactElement } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ModalDialogueContext, ModalDialogueWindow } from 'idsk-react-components';
import { ResponsiveContext } from 'slovlex-idsk-react-components';
import PripomienkyRouter from './routing/PripomienkyRouter';
import ScrollToTop from './module/ScrollToTop';
import { ClientStatusContextProvider } from './context/ClientStatusContext';
import { SuccessMessageContextProvider } from './context/SuccessMessageContext';
import { ErrorMessageContextProvider } from './context/ErrorMessageContext';
import { CallbackContextProvider } from './context/CallbackActionContext';
import './main.scss';
import { HistoryContextProvider } from './context/HistoryContext';
import { UserContextProvider } from './context/UserContext';
import { SecurityContextProvider } from './context/SecurityContext';
import initAxios from './configuration/axiosConfig';
import { StadiumMaterialuHistoriaContextProvider } from './context/StadiumMaterialuHistoriaContext';
import SprievodnyDokumentContextProvider
  from './context/SprievodnyDokumentContext/SprievodnyDokumentContextProvider';
import { ConfirmActionContextProvider } from './context/ConfirmActionContext';

initAxios();

const App = (): ReactElement => (
  <React.StrictMode>
    <BrowserRouter basename={process.env.REACT_APP_SUBPATH}>
      <ModalDialogueContext>
        <ResponsiveContext maxDesktopValuePx={640}>
          <SuccessMessageContextProvider>
            <ErrorMessageContextProvider>
              <ModalDialogueWindow />
              <HistoryContextProvider>
                <SecurityContextProvider>
                  <ClientStatusContextProvider>
                    <ConfirmActionContextProvider>
                      <CallbackContextProvider>
                        <UserContextProvider>
                          <StadiumMaterialuHistoriaContextProvider>
                            <SprievodnyDokumentContextProvider>
                              <>
                                <ScrollToTop />
                                <PripomienkyRouter />
                              </>
                            </SprievodnyDokumentContextProvider>
                          </StadiumMaterialuHistoriaContextProvider>
                        </UserContextProvider>
                      </CallbackContextProvider>
                    </ConfirmActionContextProvider>
                  </ClientStatusContextProvider>
                </SecurityContextProvider>
              </HistoryContextProvider>
            </ErrorMessageContextProvider>
          </SuccessMessageContextProvider>
        </ResponsiveContext>
      </ModalDialogueContext>
    </BrowserRouter>
  </React.StrictMode>
);

export default App;
